import type { FC } from 'react';

interface INotificationDropDownList {
	notification: string;
	handleNotificationAction?: () => void;
	cta?: JSX.Element;
}

export const NotificationDropDownItem: FC<INotificationDropDownList> = ({ notification, handleNotificationAction, cta }) => (
	<>
		{notification && (
			<li
				className='dropdown-item f-row-7 py-2 border-label-bottom cursor-pointer'
				onClick={handleNotificationAction}
			>
				<div className='f-column-11'>
					<p className='font-12 m-0'>{notification}</p>

					{cta}
				</div>
			</li>
		)}
	</>
);
